import { render } from "./createAdmin.vue?vue&type=template&id=99e37c5e"
import script from "./createAdmin.vue?vue&type=script&lang=js"
export * from "./createAdmin.vue?vue&type=script&lang=js"

import "./createAdmin.vue?vue&type=style&index=0&id=99e37c5e&lang=css"

import exportComponent from "/Users/1M/Projects/SLE/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__